<script setup>
  const props = defineProps({
    hasShadow: {
      default: true,
      type: Boolean,
      required: false
    }
  });
</script>

<template>
  <div :class="[props.hasShadow ? 'shadow' : 'null']">
    <slot name="header" />
    <slot name="body">
      Card body
    </slot>
    <slot name="footer" />
  </div>
</template>

<style scoped>

</style>